/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { NM } from '../utils/constants';
import { mlSafe, fu } from '../utils/format';


function FormattedInput({ value, onChange, disabled }) {
  const [focused, setFocused] = React.useState(false);
  const display = focused
    ? (value || '')
    : (parseFloat(value) > 0 ? Math.round(parseFloat(value)).toLocaleString('en-US') : (value || ''));
  return (
    <input
      type={focused ? 'number' : 'text'}
      value={display}
      disabled={disabled}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onChange={e => onChange(e.target.value)}
      style={{ width: '100%', background: 'transparent', border: 'none', outline: 'none',
        color: 'var(--t1)', fontSize: 11, fontFamily: 'var(--sans)',
        textAlign: 'right', padding: 0, margin: 0, lineHeight: 1, display: 'block' }}
    />
  );
}

export default function OverheadsPanel({
  categories, values, loaded,
  addCategory, updateCategory, deleteCategory,
  addSub, updateSub, deleteSub,
  updateValue,
  getCategoryMonthlyTotal,
  startDate,
  functionalCurrency,
  getActualsForMonth,
  currentMonthIdx,
  plActuals,
  plMappings,
}) {
  const fc = functionalCurrency || 'USD';
  const [collapsed, setCollapsed] = useState({});
  const [newSubName, setNewSubName] = useState({});

  if (!loaded) return <div className="panel"><p className="nomsg">Loading…</p></div>;

  const toggleCollapse = (id) => setCollapsed(prev => ({ ...prev, [id]: !prev[id] }));

  const hdr = (
    <thead>
      <tr>
        <th style={{ textAlign: 'left', minWidth: 200 }}></th>
        {Array.from({ length: NM }, (_, i) => (
          <th key={i}>{mlSafe(i, startDate)}</th>
        ))}
      </tr>
    </thead>
  );

  const aboveEbitda = categories.filter(c => !c.belowEbitda);
  const belowEbitda  = categories.filter(c => c.belowEbitda);

  const renderCategory = (cat) => {
        const catTotal = getCategoryMonthlyTotal ? getCategoryMonthlyTotal(cat.id) : Array(NM).fill(0);
        const isCollapsed = collapsed[cat.id];

        return (
          <div key={cat.id} className="card" style={{ marginBottom: 14 }}>
            <div className="card-head" style={{ cursor: 'pointer' }} onClick={() => toggleCollapse(cat.id)}>
              <span className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 9, color: 'var(--blue)' }}>{isCollapsed ? '▸' : '▾'}</span>
                <input
                  className="lbl-i"
                  value={cat.name}
                  onClick={e => e.stopPropagation()}
                  onChange={e => updateCategory(cat.id, e.target.value)}
                  style={{ fontSize: 11, fontWeight: 600, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--t2)', background: 'none', border: 'none', outline: 'none', width: 200 }}
                />
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 11, color: 'var(--t2)', fontWeight: 500 }}>
                  {catTotal.some(v => v > 0) ? fu(catTotal.reduce((a, v) => a + v, 0)) + ' / yr' : ''}
                </span>
                <button className="rm" onClick={e => { e.stopPropagation(); deleteCategory(cat.id); }}>×</button>
              </div>
            </div>

            {!isCollapsed && (
              <div className="card-body" style={{ padding: 0 }}>
                <div className="tw">
                  <table className="dt">
                    {hdr}
                    <tbody>
                      {cat.subs.map(sub => (
                        <tr key={sub.id} style={{ borderBottom: '1px solid var(--e0)' }}>
                          <td style={{ padding: '0 8px', height: 22, verticalAlign: 'middle', background: 'var(--s1)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                              <input
                                value={sub.name}
                                onChange={e => updateSub(cat.id, sub.id, e.target.value)}
                                style={{ flex: 1, background: 'transparent', border: 'none', outline: 'none',
                                  color: 'var(--t2)', fontSize: 10, fontFamily: 'var(--sans)',
                                  cursor: 'text', padding: 0, lineHeight: 1 }}
                              />
                              <button className="rm" style={{ fontSize: 10, lineHeight: 1, padding: '0 2px' }}
                                onClick={() => deleteSub(cat.id, sub.id)}>×</button>
                            </div>
                          </td>
                          {Array.from({ length: NM }, (_, i) => (
                            <td key={i} style={{ padding: '0 4px', height: 22, verticalAlign: 'middle' }}>
                              {(() => {
                                const isLocked = currentMonthIdx !== null && currentMonthIdx !== undefined && i <= currentMonthIdx;
                                if (isLocked && startDate && plActuals && plMappings) {
                                  const totalMonths = startDate.month + i;
                                  const yr = startDate.year + Math.floor(totalMonths / 12);
                                  const mo = ((totalMonths % 12) + 12) % 12;
                                  const monthKey = `${yr}-${String(mo + 1).padStart(2, '0')}`;
                                  const monthActuals = plActuals[monthKey] || {};
                                  let total = 0; let hasData = false;
                                  Object.entries(monthActuals).forEach(([accName, val]) => {
                                    const mapping = plMappings[accName];
                                    if (mapping?.targetId === sub.id && (mapping?.type === 'overhead_sub' || mapping?.type === 'below_ebitda_sub')) {
                                      total += parseFloat(val) || 0;
                                      hasData = true;
                                    }
                                  });
                                  if (hasData) return (
                                    <span style={{ fontSize: 10, color: 'var(--blue)', display: 'block',
                                      textAlign: 'right', padding: '0 2px', fontFamily: 'var(--sans)' }}
                                      title={`Actual: ${monthKey}`}>
                                      {Math.round(total).toLocaleString()}
                                    </span>
                                  );
                                }
                                // Locked month but no actuals mapping — show 0 (old manual input ignored)
                                if (isLocked) {
                                  return <span style={{ fontSize: 10, color: 'var(--t4)', display: 'block',
                                    textAlign: 'right', padding: '0 2px', fontFamily: 'var(--sans)' }}
                                    title="No actuals mapped">—</span>;
                                }
                                return <FormattedInput value={values[sub.id]?.[i] || ''} onChange={v => updateValue(sub.id, i, v)} />;
                              })()}
                            </td>
                          ))}
                        </tr>
                      ))}
                      {cat.subs.length === 0 && (
                        <tr className="rc">
                          <td colSpan={NM + 1} style={{ color: 'var(--t4)', fontSize: 11, fontStyle: 'italic' }}>
                            No sub-categories yet — add one below
                          </td>
                        </tr>
                      )}
                      <tr className="rg">
                        <td>Total {cat.name}</td>
                        {catTotal.map((v, i) => (
                          <td key={i}>{v > 0 ? fu(v) : '—'}</td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div style={{ padding: '10px 16px', display: 'flex', gap: 8, borderTop: '1px solid var(--e0)' }}>
                  <input
                    style={{ flex: 1, maxWidth: 220, background: 'var(--s2)', border: '1px solid var(--e1)',
                      borderRadius: 'var(--r)', padding: '5px 8px', fontSize: 12, color: 'var(--t1)',
                      outline: 'none', fontFamily: 'var(--sans)' }}
                    placeholder="New sub-category name…"
                    value={newSubName[cat.id] || ''}
                    onChange={e => setNewSubName(prev => ({ ...prev, [cat.id]: e.target.value }))}
                    onKeyDown={e => {
                      if (e.key === 'Enter' && newSubName[cat.id]?.trim()) {
                        addSub(cat.id, newSubName[cat.id].trim());
                        setNewSubName(prev => ({ ...prev, [cat.id]: '' }));
                      }
                    }}
                  />
                  <button className="action-btn secondary"
                    onClick={() => {
                      if (newSubName[cat.id]?.trim()) {
                        addSub(cat.id, newSubName[cat.id].trim());
                        setNewSubName(prev => ({ ...prev, [cat.id]: '' }));
                      }
                    }}>
                    + Add
                  </button>
                </div>
              </div>
            )}
          </div>
        );
  };

  return (
    <div>
      {aboveEbitda.map(cat => renderCategory(cat))}

      {/* Add new above-EBITDA category */}
      {addCategory ? <AddCategoryRow onAdd={addCategory} /> : null}

      {/* Below EBITDA section */}
      <div style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '0 0 12px' }}>
          <div style={{ flex: 1, height: 1, background: 'var(--e1)' }} />
          <span style={{ fontSize: 9, letterSpacing: '.18em', textTransform: 'uppercase', color: 'var(--t4)', whiteSpace: 'nowrap' }}>
            Below EBITDA
          </span>
          <div style={{ flex: 1, height: 1, background: 'var(--e1)' }} />
        </div>
        {belowEbitda.map(cat => renderCategory(cat))}
      </div>
    </div>
  );
}

function AddCategoryRow({ onAdd }) {
  const [name, setName] = useState('');
  return (
    <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
      <input
        style={{ flex: 1, maxWidth: 250, background: 'var(--s2)', border: '1px solid var(--e1)',
          borderRadius: 'var(--r)', padding: '6px 10px', fontSize: 12, color: 'var(--t1)',
          outline: 'none', fontFamily: 'var(--sans)' }}
        placeholder="New category name…"
        value={name}
        onChange={e => setName(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter' && name.trim()) { onAdd(name.trim()); setName(''); }
        }}
      />
      <button className="action-btn secondary"
        onClick={() => { if (name.trim()) { onAdd(name.trim()); setName(''); } }}>
        + Add Category
      </button>
    </div>
  );
}
